import type { VoidFunctionComponent } from 'react';

import { FormLabelVariant } from '../Forms';
import LabeledTextInput from '../Forms/LabeledTextInput';
import type { LabeledTextInputProps } from '../Forms/LabeledTextInput';

type Props = Omit<LabeledTextInputProps, 'size' | 'labelVariant'>;

/**
 * FilterCardTextInput is a thin wrapper around our LabeledTextInput component,
 * setting some common default props (like size: small) and making
 * it easier to use a LabeledTextInput in the context of a FilterCard.
 */
const FilterCardTextInput: VoidFunctionComponent<Props> = ({
  label,
  placeholder,
  value,
  onChange,
  isDisabled,
  testId,
}) => (
  <LabeledTextInput
    size="small"
    labelVariant={FormLabelVariant.Filter}
    label={label}
    placeholder={placeholder}
    value={value}
    isDisabled={isDisabled}
    onChange={onChange}
    testId={testId}
  />
);

export default FilterCardTextInput;
